<!-- @format -->

<tooltip>
  <div class="tooltip_container">
    <div class="btn_tooltip js-tooltip"><a href="#">?</a></div>
    <div class="tooltip">
      <p class="tooltip_txt"></p>
    </div>
    <!--/.tooltip-->
  </div>
  <!--	/.tooltip_container-->
  <script>
    export default {
      onMounted() {
        //ツールチップ
        const e = this.$(".js-tooltip");
        window.$(e).hover(
          function () {
            window.$(this).next(".tooltip").addClass("active");
          },
          function () {
            window.$(this).next(".tooltip").removeClass("active");
          }
        );
        this.onUpdated();
      },
      onUpdated() {
        if (this.$(".tooltip_txt")) {
          this.$(".tooltip_txt").innerHTML = this.props.text;
        }
      },
    };
  </script>
</tooltip>
